(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bookilicious-gift-benefits"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-gift-scroll]');
  if (!button) return;
  const list = document.getElementById(button.getAttribute('aria-controls'));
  if (!list) return;
  const direction = getComputedStyle(list).direction === 'rtl' ? -1 : 1;
  const step = button.dataset.giftScroll === 'next' ? 1 : -1;
  const card = list.querySelector('.gift-benefits__card');
  const distance = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(list).columnGap) : list.clientWidth;
  list.scrollBy({left: direction * step * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bookilicious-premium-home"] && !Shopify.designMode) return;
  try {
    
function setupTrustTickers(){
  document.querySelectorAll('[data-trust-ticker]').forEach(ticker=>{
    if(ticker.dataset.bound)return;
    ticker.dataset.bound='true';
    const button=ticker.querySelector('.premium-trust-toggle');
    button.addEventListener('click',()=>{
      const paused=ticker.classList.toggle('is-paused');
      button.setAttribute('aria-pressed',String(paused));
      button.setAttribute('aria-label',paused?button.dataset.playLabel:button.dataset.pauseLabel);
      button.querySelector('span').textContent=paused?'▷':'Ⅱ';
    });
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupTrustTickers);else setupTrustTickers();
document.addEventListener('shopify:section:load',setupTrustTickers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bookilicious-sticky-purchase"]) return;
  try {
    
function setupRefinedSticky(){
  const bar=document.querySelector('[data-refined-sticky]');
  if(!bar||bar.dataset.bound)return;
  const main=document.querySelector('product-info');
  const native=main?.querySelector('.product-form__submit');
  if(!native)return;
  bar.dataset.bound='true';
  const button=bar.querySelector('[data-refined-submit]');
  const price=bar.querySelector('[data-refined-price]');
  const mirror=()=>{button.disabled=native.disabled;button.textContent=native.querySelector('span')?.textContent.trim()||native.textContent.trim();const current=main.querySelector('.price__regular .price-item--regular');const sale=main.querySelector('.price--on-sale .price-item--sale');if(sale||current)price.textContent=(sale||current).textContent.trim();};
  button.addEventListener('click',()=>{if(!native.disabled)native.click();});
  new IntersectionObserver(entries=>{bar.hidden=entries[0].isIntersecting||native.getBoundingClientRect().top>window.innerHeight;},{threshold:0}).observe(native);
  new MutationObserver(mirror).observe(main,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled']});
  mirror();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupRefinedSticky);else setupRefinedSticky();
document.addEventListener('shopify:section:load',setupRefinedSticky);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
